const persistFeedbackDictionary = {
  persistFeedback: {
    successMessage: "Successfully saved!",
    afterPersistErrorMessage: "Something wrong has happened after the data were persisted. Please refresh the page.",
    errorMessage: "Failed to save. Please try again."
  }
};
export {
  persistFeedbackDictionary
};
//# sourceMappingURL=persistFeedbackDictionary.js.map
